/**
 * South African Universities list
 */

export const universities = [
  { name: 'Cape Peninsula University of Technology', domain: '@mycput.ac.za' },
  { name: 'Central University of Technology', domain: '@cut.ac.za' },
  { name: 'Durban University of Technology', domain: '@dut.ac.za' },
  { name: 'Mangosuthu University of Technology', domain: '@mut.ac.za' },
  { name: 'Nelson Mandela University', domain: '@mandela.ac.za' },
  { name: 'North-West University', domain: '@mynwu.ac.za' },
  { name: 'Rhodes University', domain: '@campus.ru.ac.za ' },
  { name: 'Sefako Makgatho Health Sciences University', domain: '@swave.smu.ac.za' },
  { name: 'Sol Plaatje University', domain: '@spu.ac.za' },
  { name: 'Stellenbosch University', domain: '@sun.ac.za' },
  { name: 'Tshwane University of Technology', domain: '@tut.ac.za' },
  { name: 'University of Cape Town', domain: '@myuct.ac.za' },
  { name: 'University of Fort Hare', domain: '@ufh.ac.za' },
  { name: 'University of Johannesburg', domain: '@student.uj.ac.za' },
  { name: 'University of KwaZulu-Natal', domain: '@stu.ukzn.ac.za' },
  { name: 'University of Limpopo', domain: '@keyaka.ul.ac.za' },
  { name: 'University of Mpumalanga', domain: '@ump.ac.za' },
  { name: 'University of Pretoria', domain: '@tuks.co.za' },
  { name: 'University of South Africa', domain: '@mylife.unisa.ac.za' },
  { name: 'University of the Free State', domain: '@ufs4life.ac.za' },
  { name: 'University of the Western Cape', domain: '@myuwc.ac.za' },
  { name: 'University of the Witwatersrand', domain: '@wits.ac.za' },
  { name: 'University of Zululand', domain: '@unizulu.ac.za' },
  { name: 'Vaal University of Technology', domain: '@edu.vut.ac.za' },
  { name: 'Walter Sisulu University', domain: '@mywsu.ac.za' }
].sort((a, b) => a.name.localeCompare(b.name));